import equal from 'fast-deep-equal/react';
import { RootState, useAppSelector } from '~/Store';
import { isAlreadyPurchased } from '~/utils/purchase';

const stateSelector = (state: RootState) => {
    return {
        accountId: state.account?.id,
        deniedBundlesByUniqueItems: state.account?.deniedBundlesByUniqueItems,
        purchasedLimitedBundles: state.account?.purchasedLimitedBundles,
    };
};

const useAlreadyPurchased = (bundle: IBundle) => {
    const { deniedBundlesByUniqueItems, purchasedLimitedBundles } = useAppSelector(stateSelector, equal);
    return isAlreadyPurchased(purchasedLimitedBundles, deniedBundlesByUniqueItems, bundle);
};

export default useAlreadyPurchased;
